import day from 'utils/day';

const todayDate = day();
export const exercise = {
  total: 1,
  data: [
    {
      id: 321,
      name: 'Aerobics',
      date: todayDate.format('MM/DD/YYYY'),
      intensity: '1',
      duration: 11,
      caloriesBurned: 93.68,
      migratedAt: null,
      createdAt: '2021-01-12T23:01:52.462Z',
      updatedAt: '2021-01-12T23:01:52.462Z',
      createdBy: 173,
      updatedBy: 173,
      patientId: 109,
    },
  ],
};
export const createExercise = {
  id: 149,
  caloriesBurned: 93.68,
  duration: 11,
  date: todayDate.format('MM/DD/YYYY'),
  name: 'Aerobics',
  createdBy: 173,
  updatedBy: 173,
  patientId: 109,
  updatedAt: '2021-02-18T13:20:45.828Z',
  createdAt: '2021-02-18T13:20:45.828Z',
  intensity: null,
  migratedAt: null,
};
export const exercisesData = {
  A: [
    {
      id: 54,
      name: 'Aerobics',
      description: null,
      createdAt: '2020-07-02T09:25:58.482Z',
      updatedAt: '2020-07-02T09:25:58.482Z',
      createdBy: null,
      updatedBy: null,
    },
  ],
  B: [
    {
      id: 2,
      name: 'Ballroom dancing',
      description: null,
      createdAt: '2020-03-24T13:06:14.201Z',
      updatedAt: '2020-03-24T13:06:14.201Z',
      createdBy: null,
      updatedBy: null,
    },
    {
      id: 3,
      name: 'Barre',
      description: null,
      createdAt: '2020-03-24T13:06:14.201Z',
      updatedAt: '2020-03-24T13:06:14.201Z',
      createdBy: null,
      updatedBy: null,
    },
    {
      id: 4,
      name: 'Basketball',
      description: null,
      createdAt: '2020-03-24T13:06:14.201Z',
      updatedAt: '2020-03-24T13:06:14.201Z',
      createdBy: null,
      updatedBy: null,
    },
    {
      id: 5,
      name: 'Bicycling',
      description: null,
      createdAt: '2020-03-24T13:06:14.201Z',
      updatedAt: '2020-03-24T13:06:14.201Z',
      createdBy: null,
      updatedBy: null,
    },
    {
      id: 7,
      name: 'Boxing',
      description: null,
      createdAt: '2020-03-24T13:06:14.201Z',
      updatedAt: '2020-03-24T13:06:14.201Z',
      createdBy: null,
      updatedBy: null,
    },
  ],
};
